// Typography — Palette house law: TWO self-hosted families, no system stack.
// Jost carries Latin and the tabular figures every readout depends on;
// Prompt carries the Thai script at a matched weight and rhythm.
// The stack falls back per glyph, so a mixed Thai/Latin line needs no
// language switch and no third family.
//
// The previous five IBM Plex / Lora packages are gone: none of them was
// actually the design face (the UI used a 'Helvetica Neue' system stack),
// IBM Plex Sans Thai was imported and referenced zero times, and Lora was
// referenced only by the sentence that named it.
import "@fontsource/jost/latin-400.css";
import "@fontsource/jost/latin-500.css";
import "@fontsource/jost/latin-600.css";
import "@fontsource/jost/latin-700.css";
import "@fontsource/jost/latin-ext-400.css";
import "@fontsource/jost/latin-ext-500.css";
import "@fontsource/jost/latin-ext-600.css";
import "@fontsource/jost/latin-ext-700.css";
import "@fontsource/prompt/thai-400.css";
import "@fontsource/prompt/thai-500.css";
import "@fontsource/prompt/thai-600.css";
import "@fontsource/prompt/thai-700.css";
import "@fontsource/prompt/latin-400.css";
import "@fontsource/prompt/latin-500.css";
import "@fontsource/prompt/latin-600.css";
import "@fontsource/prompt/latin-700.css";

import "./styles/tokens.css";
import "./styles/layout.css";
import "./styles/atlas.css";
import "./styles/platform.css";
import "./styles/terminal.css";
import "maplibre-gl/dist/maplibre-gl.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Root } from "./Root";
import { ErrorBoundary } from "./components/ErrorBoundary";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");
createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <Root />
    </ErrorBoundary>
  </StrictMode>,
);
